import audio from '../../../../assets/audio/kids-tracks/Text9.mp3';

export const step10talk = {
    id: 10,
    title: 'Značka',
    taskText: `
        <p>
            Jsi šikula, teď můžeme pokračovat. Vidíš tu značku, co je támhle kousek po cestě? Prý máme dojít až k ní a tam se dozvíme co dál. Tak jdeme! 
        </p>
    `,
    continueButtonText: 'Pokračovat',
    points: false,
    audio: audio,
};
